import * as Actions from '../actions';

const initialState = {
	campaigns: [],
	currentCampaign: null,
	error: null,
	loading: false
};

const campaignReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.GET_CAMPAIGNS: {
			return {
				...state,
				campaigns: action.payload,
				loading: false,
				error: null
			};
		}

		case Actions.GET_CAMPAIGN: {
			return {
				...state,
				currentCampaign: action.payload,
				loading: false,
				error: null
			};
		}

		case Actions.CREATE_CAMPAIGN: {
			return {
				...state,
				loading: false,
				error: null
			};
		}

		case Actions.UPDATE_CAMPAIGN: {
			return {
				...state,
				currentCampaign: action.payload,
				loading: false,
				error: null
			};
		}

		case Actions.DELETE_CAMPAIGN: {
			return {
				...state,
				campaigns: state.campaigns.filter(campaign => campaign._id !== action.payload),
				loading: false,
				error: null
			};
		}

		case Actions.CAMPAIGN_ERROR: {
			return {
				...state,
				error: action.payload,
				loading: false
			};
		}

		case Actions.CLEAR_CAMPAIGN_ERROR: {
			return {
				...state,
				error: null
			};
		}

		default: {
			return state;
		}
	}
};

export default campaignReducer;
